var _path, _path2, _path3, _path4, _path5;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFoodAndWine = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M28.3333 25C23.7317 25 20 21.2683 20 16.6667V8.33333C20 6.49167 21.4917 5 23.3333 5H33.3333C35.175 5 36.6667 6.49167 36.6667 8.33333V16.6667C36.6667 21.2683 32.935 25 28.3333 25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M8.33325 22.5H15.5716C17.3399 22.5 19.0349 23.2017 20.2849 24.4533L30.8333 35H19.9999L8.33325 22.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1317 30H30.7983V24.5867C34.1883 23.5317 36.6667 20.405 36.6667 16.6667H20C20 20.3783 22.4433 23.4867 25.7983 24.565V30L30.7983 35H34.1317C35.5133 35 36.6317 33.8817 36.6317 32.5C36.6317 31.1183 35.5117 30 34.1317 30Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8334 31.6667C19.7334 31.6667 18.81 32.3817 18.4767 33.3667L14.4484 29.05C14.7884 28.6233 15 28.0883 15 27.5C15 26.12 13.88 25 12.5 25C11.9717 25 11.485 25.165 11.0817 25.445L8.33337 22.5C1.6667 28.3333 4.1667 35 4.1667 35H18.3334H20H23.18C23.2734 34.7383 23.3334 34.46 23.3334 34.1667C23.3334 32.7867 22.2134 31.6667 20.8334 31.6667Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 28.3333C22.3433 28.3333 22.92 27.9267 23.18 27.3467L20.985 25.1517C20.4067 25.4133 20 25.99 20 26.6667C20 27.5867 20.7467 28.3333 21.6667 28.3333Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFoodAndWine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/food-and-wine.1cd8a6a1.svg";
export { ForwardRef as ReactComponent };